/* eslint-disable @typescript-eslint/naming-convention */
import { Dispatch } from 'react';

import { creditTiers } from '../common/constants';
import { LoanTerms } from '../common/types';

export type CreditTiersType = (typeof creditTiers)[keyof typeof creditTiers];

export interface MonthlyPaymentState {
  homePrice: number;
  downPayment: number;
  downPaymentPercent: number;
  loanTerm: LoanTerms;
  interestRate: number;
  propertyTaxAnnual: number;
  homeownersInsuranceMonthly: number;
  hoaFeesMonthly: number;
  showFull: boolean;
}

export enum MonthlyPaymentDataActionsTypes {
  SET_HOME_PRICE,
  SET_DOWN_PAYMENT,
  SET_DOWN_PAYMENT_PERCENT,
  SET_LOAN_TERM,
  SET_INTEREST_RATE,
  SET_PROPERTY_TAX_ANNUAL,
  SET_HOMEOWNTERS_INSURANCE_MONTHLY,
  SET_HOA_FEES_MONTHLY,
  SET_SHOW_FULL,
  SET_DEFAULTS
}

export type MonthlyPaymentDataActions =
  | {
      type: MonthlyPaymentDataActionsTypes.SET_HOME_PRICE;
      payload: MonthlyPaymentState['homePrice'];
    }
  | {
      type: MonthlyPaymentDataActionsTypes.SET_DOWN_PAYMENT;
      payload: MonthlyPaymentState['downPayment'];
    }
  | {
      type: MonthlyPaymentDataActionsTypes.SET_DOWN_PAYMENT_PERCENT;
      payload: MonthlyPaymentState['downPaymentPercent'];
    }
  | {
      type: MonthlyPaymentDataActionsTypes.SET_LOAN_TERM;
      payload: MonthlyPaymentState['loanTerm'];
    }
  | {
      type: MonthlyPaymentDataActionsTypes.SET_INTEREST_RATE;
      payload: MonthlyPaymentState['interestRate'];
    }
  | {
      type: MonthlyPaymentDataActionsTypes.SET_PROPERTY_TAX_ANNUAL;
      payload: MonthlyPaymentState['propertyTaxAnnual'];
    }
  | {
      type: MonthlyPaymentDataActionsTypes.SET_HOMEOWNTERS_INSURANCE_MONTHLY;
      payload: MonthlyPaymentState['homeownersInsuranceMonthly'];
    }
  | {
      type: MonthlyPaymentDataActionsTypes.SET_HOA_FEES_MONTHLY;
      payload: MonthlyPaymentState['hoaFeesMonthly'];
    }
  | {
      type: MonthlyPaymentDataActionsTypes.SET_SHOW_FULL;
      payload: MonthlyPaymentState['showFull'];
    }
  | {
      type: MonthlyPaymentDataActionsTypes.SET_DEFAULTS;
    };

export type MonthlyPaymentContextType = {
  state: MonthlyPaymentState;
  dispatch: Dispatch<MonthlyPaymentDataActions>;
  getMonthlyPayment: () => number;
  getPropertyTaxesMonthly: () => number;
  getMonthlyPrincipalAndInterest: () => number;
  getMortgageSize: () => number;
  getMortgageInterest: () => number;
  getTotalMortgagePaind: () => number;
};
